import React,{useState} from "react";
import styled from "styled-components";
import theme from "../theme";
import {ReactComponent as IconoDown} from './../imagenes/down.svg';
import { ReactComponent as IconoPasajero } from './../imagenes/pasajero.svg';
import { ReactComponent as IconoTelefono } from './../imagenes/telefono.svg';
import { ReactComponent as IconoOrigen } from './../imagenes/origen.svg';
import { ReactComponent as IconoDestino } from './../imagenes/destino.svg';

const ElementoLista = styled.li`
    padding: 0.2rem 0; /* 20px */
    border: 1px solid #c6c6c6;
    background: ${theme.grisClaro};
    display: grid;
    gap: 0.3rem; /* 5px */
    justify-content: space-between;
    border-radius: 1rem; /* 5px */
    text-transform: uppercase;
    & > div {
        width: 100%;
        display: flex;
        align-items: center;
    }
 
    &:hover button,
    &:hover a {
        opacity: 1;
    }
`;

const Lista = styled.ul`
    list-style: none;
    padding: 0 0.3rem; /* 40px */
    height: 100%;
    overflow-y: auto;
 
    li {
        grid-template-columns: 1fr 0.5fr 1.5fr 1.5fr;
    }
 
    @media (max-width: 50rem) { /*80px*/
        li {
            grid-template-columns: 0.3fr 1fr;
            grid-template-rows: 1fr 0.3fr;
        }
    }
`;

const Descripcion = styled.div`
    justify-content: left;
    font-size: 0.8rem;
    text-transform: uppercase;
    @media (max-width: 20rem) { /* 50px */
        justify-content: end;
    }
`;

const BotonAccion = styled.button`
    outline: none;
    background: ${theme.grisClaro};
    border: none;
    width: 2.5rem; /* 40px */
    display: inline-block;
    height: 2.5rem; /* 40px */
    line-height: 2.5rem; /* 40px */
    font-size: 16px;
    cursor: pointer;
    border-radius: 0.31rem; /* 5px */
    margin-left: 0.625rem; /* 10px */
    transition: .3s ease all;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
 
    &:hover {
        background: ${theme.grisClaro2};
    }
 
    svg {
        width: 1.125rem; /* 18px */
    }
 
    @media (max-width: 50rem) { /* 80px */
        opacity: 1;
    }
`;

const SelectPasajeros = (pasajeros) => {
    //console.log(pasajeros)
    if(pasajeros.hasOwnProperty("pasajeros"))
    {    const pasajeros2 = Object.keys(pasajeros.pasajeros).map(function (key) {return {id : key, ...pasajeros.pasajeros[key]};});
    //	const handleClick = (e) => {cambiarPasajeros(e.currentTarget.dataset.valor);}
    
    
        return (
            <Lista>
            {pasajeros2.map((pasajero) => {


                if (pasajero.direccion_o===null || pasajero.direccion_d===null || pasajero.direccion_o===null || pasajero.direccion_d===null ){
                    return(
                        <ElementoLista>
                                       <Descripcion><IconoPasajero/>&nbsp;{pasajero.nombre}</Descripcion>
                                      <Descripcion><IconoTelefono/>&nbsp;{pasajero.telefono}</Descripcion>
                                      <Descripcion><IconoDestino/>&nbsp;{pasajero.direccion_o}</Descripcion>
                                      <Descripcion><IconoDestino/>&nbsp;{pasajero.direccion_d}</Descripcion>
                        </ElementoLista>
                         )

                } else {
                    
                    if (pasajero.hasOwnProperty("direccion_o") && pasajero.hasOwnProperty("direccion_d")  && pasajero.hasOwnProperty("nombre") ) {
                    return(
                        <ElementoLista  key={pasajero.id}>
                            
                            <Descripcion><IconoPasajero/>&nbsp;{pasajero.nombre.substring(0, 33)}</Descripcion>
                          <Descripcion><IconoTelefono/>&nbsp;{pasajero.telefono}</Descripcion>
                          {!(pasajero.direccion_o.substring(0, 10)  === 'AEROPUERTO' || pasajero.direccion_o.substring(0, 10)  === 'Aeropuerto' ) 
                                ? <Descripcion><IconoOrigen/>&nbsp;{pasajero.direccion_o.substring(0, 60)}</Descripcion>
                                : <Descripcion style={{backgroundColor: "#d4fdc3"}}><IconoOrigen/>&nbsp;{pasajero.direccion_o.substring(0, 60)}</Descripcion>
                                }
            
                        {!(pasajero.direccion_d.substring(0, 10)  === 'AEROPUERTO' || pasajero.direccion_d.substring(0, 10)  === 'Aeropuerto' ) 
                                ? <Descripcion><IconoDestino/>&nbsp;{pasajero.direccion_d.substring(0, 60)}</Descripcion>
                                : <Descripcion style={{backgroundColor: "#d4fdc3"}}><IconoDestino/>&nbsp;{pasajero.direccion_d.substring(0, 60)}</Descripcion>
                                }
            
                         </ElementoLista>
                         )
                        } else {
                            {
                                return(
                                    <ElementoLista>
                                       <Descripcion><IconoPasajero/>&nbsp;{pasajero.nombre}</Descripcion>
                                      <Descripcion><IconoTelefono/>&nbsp;{pasajero.telefono}</Descripcion>
                                      <Descripcion><IconoDestino/>&nbsp;{pasajero.direccion_o}</Descripcion>
                                      <Descripcion><IconoDestino/>&nbsp;{pasajero.direccion_d}</Descripcion>
                                    </ElementoLista>
                                     )
            
                            }
                        }

                }

               })}
            </Lista>
    
    
        );}

    else{        
        
        return (
        <Lista>
          return(
            <ElementoLista>
              <Descripcion><IconoPasajero/>Sin Datos</Descripcion>
              <Descripcion><IconoTelefono/>Sin Datos</Descripcion>
              <Descripcion><IconoOrigen/>Sin Datos</Descripcion>
              <Descripcion><IconoDestino/>Sin Datos</Descripcion>
            </ElementoLista>
             )
        </Lista>)};
}

export default SelectPasajeros;